// 러시아어
export default {
  LandingPage: {
    intro_sub: 'Помоги защитить природу – подари упаковке вторую жизнь',
    title: 'Samsung Upcycle-Упаковка',
    sequence1_1: 'Вместе сократим  количество мусора',
    sequence1_2:
      'Сохраним окружающую среду, сократив количество мусора. Узнайте способы повторного использования упаковки от ТВ',
    sequence2_1: 'Samsung Upcycle-Упаковка',
    sequence2_2:
      'Упаковка телевизора была разработана так, чтобы ее можно было использовать повторно. Например, в качестве домашних предметов.',
    sequence3_1: 'Следуйте пунктирный точкам на упаковке',
    sequence3_2:
      'Следуйте инструкции, чтобы создать уникальный предмет',
    sequence4_1: 'Выберите предмет который вам хотелось бы сделать',
    sequence4_2:
      'Прокрутите вниз и выберите вашу модель телевизора. Далее выберите вариант предмета, котрый вам понравится.',
    selectBox: 'Выберите вашу модель телевизора',
    moreActivity: 'Узнать больше про экологическую деятельности Samsung',
    OLED: 'OLED',
    QLED8K: 'QLED',
    UHD: 'UHD',
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace',
    thePremiere: 'The Premiere',
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar',
    Soundbar: 'Soundbar', //update
    SoundbarSet02:'Soundbar Set 2',
    SoundbarSet01:'Soundbar Set 1',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink: 'https://www.samsung.com/ru/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/ru/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/ru/sustainability/overview/',
    footer: 'На этом сайте используются файлы cookie. ',
    // </br> Нажимая ПРИНЯТЬ или продолжая просмотр сайта, вы разрешаете их использование.,
  },
  ProductPage: {
    selectDesign: 'Выберите дизайн',
    selectDesignDezeen: 'Samsung X Dezeen',
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'ТВ Консоль',
    StorageBox: 'Ящик для хранения',
    MagazineRack: 'Журнальная стойка',
    CatHouse: 'Домик для кошек',
    CatTunnel: 'Туннель для кошек',
    BookShelf: 'Книжная полка',
    DeskShelf: 'Журнальный стол',
    BlackRhino: 'Исчезающий \n вид животных: \nчерный носорог', //update
    PolarBear: 'Исчезающий \n вид животных: \nбелый медведь', //update
    SeaTurtle: 'Исчезающий \n вид животных: \nморская черепаха', //update
    TheRider: 'Всадник', //update
    Kibe: 'Кубы', //update
    Tessellate: 'Мозаика', //update
    Twist: 'Твист', //update
    AlexCouchArmTable: 'Кресло "Алекс"', //update
    BlastOffClubHouse: 'Дом-ракета', //update
    KinokoTable: 'Стол "Кинко"', //update
    Magnuss: 'Магнус', //update
    GIO: 'Барабан', //update
    PostCardPlanter: 'Штамп для \n открыток', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'Собан', //update
    ToolBox: 'Ящик для инструментов', //update
    DeskStationary: 'Стол ',
    // DeskStationary: 'Ящик для хранения канцелярских принадлежностей',
    CoinBank: 'Копилка',
    MobileScanner:'Подставка для сканера смартфона',
    TabletScanner:'Подставка для планшетного сканера',
    PetStairs:'Лестница для домашних животных',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'мин',
    in: 'дюйм',
    inOnly: 'дюйм только',
    allBoxSize: 'Все размеры коробки',
    all:'Все',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'Инструкции',
    prepare: 'Пожалуйста, подготовьте коробку',
    LetsDesign: 'Давайте попробуем собрать',
    drawParts: 'Нарисуйте детали на коробке ',
    note1:
      'Обратите внимание, что графическое положение может отличаться в зависимости от страны и размера коробки.',
    note2: 'Сначала нарисуйте весь эскиз так, чтобы он поместился на коробке',
    numberSpace: 'Число = Расстояние между точками',
    diagonal: 'Диагональ',
    LEFT: 'Левая сторона',
    RIGHT: 'Правая сторона',
    TOP: 'Верхняя сторона',
    TOP1: 'Верхняя сторона 1',
    TOP2: 'Верхняя сторона 2',
    BACK: 'Задняя сторона',
    MIDDLE: 'Середина',
    MIDDLE2: 'Середина 2',
    BOTTOM: 'Нижняя сторона',
    FRONT: 'Передняя сторона',
    SIDE: 'Боковая',
    secondSIDE: 'Вторая боковая',
    secondSIDE1: 'Вторая боковая 1',
    secondSIDE2: 'Вторая боковая 2',
    LEG: 'Ножки', //update
    JOINT: 'Соединительная часть', //update
    FACE: 'Лицо', //update
    DRAWERBOTTOM: 'Нижняя часть ящика', //update
    DRAWERSIDE: 'Боковая стенка ящика', //update
    NOSE: 'Нос', //update
    HANDLE: 'Ручка', //update
    BOTTOMSIDE: 'Нижняя сторона', //update
    TOPSIDE: 'Верхняя сторона', //update
    WING: 'Крыло', //update
    cutAndAssemble: 'Давайте вырежем и соберем',
    beCareful: 'Будьте осторожны! Не пораньтесь при использовании ножа',
    cutOutParts: 'Вырежьте все детали',
    assemble: 'Соберите',
    Assemblyguide: 'Инструкция по сборке', //update
    fold: 'Согните так',
    foldGuide: 'Используя твердый предмет продавите картон по линии.',
    foldGuideDezeen:
      'Чтобы сложить картон, сделайте сгиб по пунктирной линии', //update
    glue: 'Воспользуйтесь скотчем или клеем', //update
    cable: 'Для соединения используйте кабельные стяжки или веревки', //update
    done: 'Готово!',
    goBack: 'Вернуться в главное меню',
  },
  CautionPage: {
    CAUTION: 'ВНИМАНИЕ',
    needItem: 'Вам понадобятся эти инструменты',
    children: 'Присматривайте за детьми во время сборки продукта',
    mat:
      'Пожалуйста, постелите защитный коврик, чтобы не поцарапать пол во время работы',
    doNotPutHeavyThing:
      'На данную мебель нельзя наступать, садиться ,а так же нельзя ставить тяжелые предметы.',
    doNotThrow: 'Не бросайте мебель на людей и животных.',
    stayAwayFlame: 'Держите подальше от огня',
    stayAwayWater: 'Храните мебель вдали от воды и влаги',
    mayDamaged: '* ТВ коробки могут быть повреждены в процессе доставки.',
    companyDoestResponsible:
      '* Компания не несет ответственности за любые повреждения или поломки, возникшие в процессе сборки мебели.',
    cannotBeReturned:'',
    understand: 'Да, все понятно',
  },
  PrivacyPolicy: {
    title: 'Политика конфиденциальности.',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Мы подтверждаем нашу приверженность принципам устойчивого развития с помощью новой экологически чистой упаковки.',
      text2:
        'Для производства  новых ТВ  упаковок было использованно меньшее количество бумаги и чернил. Так же ее можно использовать для создания предметов домашнего обихода',
      text2_special:'',
      text3: 'Нажмите кнопку ниже, чтобы узнать больше.',
    },
    greenIn: {
      title: 'Going Green в ТВ-пакете',
      subtitle1: 'Искать информацию о продукте',
      subtitle2: 'перерабатываемый  Эко-пакет ',
      desc: 'Найдите название модели, чтобы получить дополнительную информацию',
      descM: '*Сфотографируйте номер модели телевизора',
      guide: 'Название модели',
      button: 'Take Photo',
      button2: 'Перейти к созданию предмета',
      product_info: 'Информация о продукте',
    },
    search: {
      guide: 'Поиск..',
      noResult: 'По вашему запросу ничего не найдено',
      more: 'Узнать больше',
      search: 'Искать',
      retake: 'Искать  снова',
      result: 'Result',
    },
    photo: {
      guide1: 'Вставьте название модели телевизора в поле',
      guide2: '(напрмер: Q800A, UT7000, RU7100, и т.д.)',
    },
  },
  searchCountrySelect: 'Выберите страну для поиска'
};
